// extracted by mini-css-extract-plugin
module.exports = {"mainRightSidebar":"MainRightSideBar_mainRightSidebar__bG6yF"};